import React from 'react'
import AddressSearchDialogContent from '../../routes/address/AddressSearchDialogContent'
import ItineraryResultPageClassManager from '../../routes/itinerary/ItineraryResultPageClassManager'
import { PAGE_CLASSES } from '../../routes/pageClasses.constants'
import { AdDesktopBannerItineraryResult } from '../advertising/FloatingDesktopAdBanner'
import Page from '../genericComponents/Page'
import Header from '../header/Header'
import ItineraryOptionsDialog from '../itineraryOptions/ItineraryOptionsDialog'
import ItineraryTimeOptionsDialog from '../itineraryOptions/ItineraryTimeOptionsDialog'
import Main from '../main/Main'
import Map from '../map/Map'
import SearchDialog from '../search/SearchDialog'
import ItinerarySuggestContent from '../suggest/ItinerarySuggestContent'
import UserAccountIncentiveItineraryResults from '../UserAccount/connectionIncentive/UserAccountIncentiveItineraryResults'
import ItineraryHeaderForm from './ItineraryHeaderForm'
import ItineraryResultMainContent from './ItineraryResultMainContent'
import ItinerarySubHeader from './ItinerarySubHeader'
import PoisOnRouteIncentivePopin from './PoisOnRouteIncentivePopin'
import StepsMarkers from './steps/StepsMarkers'
import Polylines from './Polylines'

export const renderPage = () => {
  const { ItineraryResultPage, withSubHeader, withToaster } = PAGE_CLASSES

  return (
    <Page
      cssClasses={[ItineraryResultPage, withSubHeader, withToaster]}
      pageClassManager={ItineraryResultPageClassManager}
      key="Page"
    >
      <Map key="Map">
        <StepsMarkers />
        <Polylines />
        <AdDesktopBannerItineraryResult />
      </Map>
      <Header key="Header" subHeader={<ItinerarySubHeader key="ItinerarySubHeader" />}>
        <ItineraryHeaderForm key="ItineraryHeaderForm" />
      </Header>
      <SearchDialog key="SearchDialog" suggestContent={<ItinerarySuggestContent />}>
        <AddressSearchDialogContent key="AddressSearchDialogContent" />
      </SearchDialog>
      <Main key="Main">
        <ItineraryResultMainContent id="ItineraryResultMainContent" />
      </Main>
      <ItineraryOptionsDialog key="ItineraryOptionsDialog" />
      <ItineraryTimeOptionsDialog key="ItineraryTimeOptionsDialog" />
      <UserAccountIncentiveItineraryResults />
      <PoisOnRouteIncentivePopin />
    </Page>
  )
}
